// Fixed lifecycle order for an enrolment — a real domain constant (not
// mock data), used to render the LifeRail progress indicator regardless
// of where the enrolment data itself comes from.
export const LIFECYCLE = ['invited', 'onboarded', 'removed', 'archived'];
